import type { IntentOption } from "../intentOptions";

// The six goals AC3 lists, in the order the signed design lists them
// (App Onboarding.dc.html, `GOALS.gallery`). Values are SignupIntent flags, so a
// selection is the same bitmask the registration POST has always carried.
//
// Two differences from galleryIntents(), which the legacy step still uses:
//
//   - "Handle consignments" is here and had no flag until this ticket added
//     Consignments = 128.
//   - "Create {venue} website" (Website = 1) is not here. AC3 leaves it out and
//     the design agrees, which makes the "Website" checklist unreachable for a
//     new gallery, since that flag is its only producer. Raised as a follow-up
//     rather than quietly restored: putting the chip back would be answering a
//     product question by omission.
//
// There is no venue interpolation left either. galleryIntents() takes a venue
// so a jewelry signup reads "Create boutique website"; with that chip gone,
// none of the six labels name the venue, so the list is a constant.
export interface GalleryGoalOption extends IntentOption {
  /**
   * The word `Intent.displayType()` puts in page/Onboarding.jsx's `'OB: Intent Declared'` payload
   * - this table's other half, on the other side of the TS/.jsx barrier (§2.6). Both wizards feed
   * the same ACA-95 funnel until the flip reaches every route, so a rebuilt event has to speak the
   * legacy event's words, not the picker's own chip copy: a dashboard filtering on "Email Campaign"
   * would silently stop seeing v2's traffic if this said "Send email campaigns" instead.
   */
  analyticsLabel: string;
}

export const GALLERY_GOALS: readonly GalleryGoalOption[] = [
  { value: 32, label: "Sell on the marketplace", analyticsLabel: "Marketplace" }, // Marketplace
  { value: 8, label: "Manage our collectors", analyticsLabel: "CRM" }, // Crm
  { value: 16, label: "Run our business", analyticsLabel: "Business Operations" }, // BusinessOperations
  { value: 2, label: "Send email campaigns", analyticsLabel: "Email Campaign" }, // EmailCampaign
  { value: 128, label: "Handle consignments", analyticsLabel: "Consignments" }, // Consignments
  { value: 4, label: "Create collateral", analyticsLabel: "Collateral" }, // Collateral
] as const;
